module.exports = __webpack_public_path__ + "static/img/img_1.6dc6cfc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_1.webp
// module id = TA49
// module chunks = 4